import { useEffect, useState } from "react";

import { api } from "@/services/api";
import type { PortGroup } from "@/types/api";
import type { PortGroupCreate } from "@/features/rates/create/wizardTypes";

/** Map API port groups to the shape used by port suggest + token expansion. */
export function portGroupApiToCreate(pg: PortGroup): PortGroupCreate {
  return {
    id: pg.id,
    name: pg.name,
    region: "",
    ports: pg.ports.map((p) => p.locode.trim().toUpperCase()),
    port_names: pg.ports.reduce<Record<string, string>>((acc, p) => {
      const locode = p.locode.trim().toUpperCase();
      acc[locode] = p.name ? `${p.name.trim()} (${locode})` : locode;
      return acc;
    }, {}),
  };
}

/** Allocation / trade-lane port groups (`GET /v1/allocations/port-groups`). */
export function useAllocationPortGroups(): {
  portGroups: PortGroupCreate[];
  loading: boolean;
} {
  const [portGroups, setPortGroups] = useState<PortGroupCreate[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .getPortGroups()
      .then((groups) => {
        if (!cancelled) {
          setPortGroups(groups.map(portGroupApiToCreate));
        }
      })
      .catch(() => {
        if (!cancelled) setPortGroups([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { portGroups, loading };
}
